import React, {Component, Fragment} from "react";
import {Button} from "reactstrap";
import {getData} from "../../api/doLogin";
import "../../containers/Calendar/views/entry.css";

export class LMSUserOrPicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      LName: null,
      FName: null,
      show: false
    }
  }

  componentDidMount() {
    this.getData(this.props.lmsID)
  }

  getData(lmsID) {
    // console.log("The lms ID", lmsID);
    if (!lmsID || lmsID === 0) {
      this.setState({show: true, FName: null, LName: null});
      return;
    }
    const self = this;
    this.setState({show: false});
    getData(`lms/${lmsID}?preview`, {}, this.props.token)
      .then((data) => {
        if (data.status === "Success") {
          self.setState({FName: data.data.lead.fname, LName: data.data.lead.lname, show: true});
        }
      }).catch((error) => {
      console.log(error);
    });
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.lmsID !== this.props.lmsID) {
      this.getData(nextProps.lmsID);
    }
  }

  isValid() {
    return !(!this.state.FName && !this.state.LName);
  }

  render() {
    if (!this.state.show) return null;
    return (
      <div style={{display: "flex", alignItems: "center"}}>
        {this.isValid() ? (
          <Fragment>
            {`${this.state.FName} ${this.state.LName}`}
            <Button color="link" className="lms-attach-lead-btns"
                    onClick={() => this.props.onViewLead && this.props.onViewLead(this.props.lmsID)}> View </Button>
            <Button color="link" className="lms-attach-lead-btns"
                    onClick={() => this.props.onRemoveLead && this.props.onRemoveLead(this.props.lmsID)}>Remove</Button>
          </Fragment>
        ) : (
          <Button onClick={() => this.props.onAttachLead && this.props.onAttachLead()}>Attach Lead</Button>
        )}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/LMSUserPicker/LMSUserOrPicker.js